export default "__VITE_ASSET__Ct$6LIOJ__"